<script setup lang="ts">
import { provide, ref, watch, type Ref } from "vue";

const props = defineProps<{
  index: number;
  item?: Record<string, any>;
  styles: Record<string, any>;
  props: Record<string, any>;
}>();
const item: Ref<Record<string, any> | undefined> = ref(props.item);
const index: Ref<number> = ref(props.index);
const styles: Ref<Record<string, any>> = ref(props.styles);
const childrenProps: Ref<Record<string, any>> = ref(props.props);

watch(
  () => props.item,
  (value) => (item.value = value)
);

watch(
  () => props.index,
  (value) => (index.value = value)
);

watch(
  () => props.styles,
  (value) => (styles.value = value)
);

watch(
  () => props.props,
  (value) => (childrenProps.value = value)
);

provide("item", item);
provide("index", index);
provide("styles", styles);
provide("props", childrenProps);
</script>
<template>
  <slot />
</template>
